import React from 'react';

export const CombinedContext = React.createContext({});
export const CombinedContextProvider = CombinedContext.Provider;
export const CombinedConsumer = CombinedContext.Consumer;

export default CombinedContext;
